<form [formGroup]="contactFilterForm">
	<modal-sidebar
		[visible]="isOpen"
		(closeModal)="closeSidebar()"
		[closeOnClickOutside]="false"
	>
		<div header class="zk-flex zk-justify-center">
			<p class="contacts-filter-title" freud-typography fontType="h4BoldAuto">
				{{ 'PAGES.CLIENTS.TABLES.FILTER.TITLE' | translate }}
			</p>
		</div>
		<div body>
			<div class="zk-flex zk-flex-col zk-gap-4">
				<p class="contacts-filter-title" freud-typography fontType="h4BoldAuto">
					{{ 'PAGES.CLIENTS.TABLES.FILTER.PROMPTUARIES.TITLE' | translate }}
				</p>
				<freud-radio-button
					formControlName="hasPromptuaryRegistered"
					[label]="
						'PAGES.CLIENTS.TABLES.FILTER.PROMPTUARIES.REGISTERED' | translate
					"
					name="hasPromptuaryRegistered"
					(valueChange)="setPromptuaryFilter(true)"
					[radioValue]="true"
					inputId="registered"
				></freud-radio-button>

				<freud-radio-button
					formControlName="hasPromptuaryRegistered"
					[label]="
						'PAGES.CLIENTS.TABLES.FILTER.PROMPTUARIES.UNREGISTERED' | translate
					"
					name="hasPromptuaryRegistered"
					(valueChange)="setPromptuaryFilter(false)"
					[radioValue]="false"
					inputId="unregistered"
				></freud-radio-button>
			</div>
			<div class="zk-flex zk-flex-col zk-gap-4 zk-mt-10">
				<p class="contacts-filter-title" freud-typography fontType="h4BoldAuto">
					{{ 'PAGES.CLIENTS.TABLES.FILTER.RETURN.TITLE' | translate }}
				</p>
				<freud-radio-button
					[(ngModel)]="daysBeforeEventDate"
					[ngModelOptions]="{ standalone: true }"
					[label]="'PAGES.CLIENTS.TABLES.FILTER.RETURN.7_DAYS' | translate"
					[name]="'daysBeforeEventDate'"
					(valueChange)="onChangeDaysBeforeEventDate(7)"
					[radioValue]="'7'"
				></freud-radio-button>

				<freud-radio-button
					[(ngModel)]="daysBeforeEventDate"
					[ngModelOptions]="{ standalone: true }"
					[label]="'PAGES.CLIENTS.TABLES.FILTER.RETURN.15_DAYS' | translate"
					[name]="'daysBeforeEventDate'"
					(valueChange)="onChangeDaysBeforeEventDate(15)"
					[radioValue]="'15'"
				></freud-radio-button>

				<freud-radio-button
					[(ngModel)]="daysBeforeEventDate"
					[ngModelOptions]="{ standalone: true }"
					[label]="'PAGES.CLIENTS.TABLES.FILTER.RETURN.30_DAYS' | translate"
					[name]="'daysBeforeEventDate'"
					(valueChange)="onChangeDaysBeforeEventDate(30)"
					[radioValue]="'30'"
				></freud-radio-button>
			</div>
			<contacts-table-baseline-filter
				[professionalType]="professionalType"
				[formGroup]="contactFilterForm"
			></contacts-table-baseline-filter>
		</div>
		<div footer class="zk-flex zk-gap-2 zk-justify-between zk-p-5">
			<freud-button
				(click)="clear()"
				color="secondary"
				id="clear-filter-button"
				(keyup)="$event.key === 'Enter' ? clear() : null"
				[disabled]="selectedFilters === 0"
				[label]="
					'PAGES.CLIENTS.TABLES.FILTER.BUTTONS.CLEAR'
						| translate: { filters: selectedFilters }
				"
			>
			</freud-button>

			<freud-button
				(click)="apply()"
				id="apply-filter-button"
				(keyup)="$event.key === 'Enter' ? apply() : null"
				[label]="'PAGES.CLIENTS.TABLES.FILTER.BUTTONS.APPLY' | translate"
			>
			</freud-button>
		</div>
	</modal-sidebar>
</form>
